import { type AxiosResponse } from 'axios'
import api from '../utils/api'

export const createDistributionPlan = async (projectId: string, data: Record<string, any>): Promise<AxiosResponse> => {
  return await api.post(`/api/distribution_series/${projectId}/slots/`, data)
}

export const updateProject = async (projectId: string, data: Record<string, any>): Promise<AxiosResponse> => {
  return await api.patch(`/api/distribution_series/${projectId}`, data)
}

export const createProject = async (data: Record<string, any>): Promise<AxiosResponse> => {
  return await api.post('/api/distribution_series/', data)
}

export const deleteProject = async ({ projectId }: { projectId: string }): Promise<AxiosResponse> => {
  return await api.delete(`/api/distribution_series/${projectId}`)
}

export const exportPdf = async (termId: string): Promise<AxiosResponse> => {
  const response = await api.get(`/api/distributions/instructor/reports/export/pdf/?term_id=${termId}`, {
    responseType: 'blob',
    headers: {
      Accept: 'application/zip'
    }
  })
  return response
}

export const exportPDFByInstructorId = async (instructorId: string, termId: string): Promise<AxiosResponse> => {
  const response = await api.get(`/api/distributions/instructor/${instructorId}/reports/export/pdf/?term_id=${termId}`, {
    responseType: 'blob',
    headers: {
      Accept: 'application/zip'
    }
  })
  return response
}

export const exportCSV = async (termId: string): Promise<AxiosResponse> => {
  const response = await api.get(`/api/distributions/instructor/reports/export/csv/?term_id=${termId}`, {
    responseType: 'blob',
    headers: {
      Accept: 'application/zip'
    }
  })
  return response
}

export const exportCSVByInstructorId = async (instructorId: string, termId: string): Promise<AxiosResponse> => {
  const response = await api.get(`/api/distributions/instructor/${instructorId}/reports/export/csv/?term_id=${termId}`, {
    responseType: 'blob',
    headers: {
      Accept: 'application/zip'
    }
  })
  return response
}

type GetAllDistributionSeriesParams = Record<string, any>
export const getAllDistributionSeries = async (params?: GetAllDistributionSeriesParams): Promise<AxiosResponse> => {
  return await api.get('/api/distribution_series/', params ? { params } : undefined)
}

export const getDistributionById = async (urlId: string, params?: Record<string, any>): Promise<AxiosResponse> => {
  return await api.get(`/api/distribution_series/${urlId}/slots/`, {
    params,
    headers: {
      Accept: 'application/cdg'
    }
  })
}
export const updateDistributionPlan = async (slotId: string, data: Record<string, any>): Promise<AxiosResponse> => {
  return await api.patch(`/api/slots/${slotId}`, data)
}

export const getProjectById = async (urlId: string, params?: Record<string, any>): Promise<AxiosResponse> => {
  return await api.get(`/api/distribution_series/${urlId}`, {
    params
  })
}

export const getInstructorDistributionsById = async (instructorId: string, params: Record<string, any>): Promise<AxiosResponse> => {
  return await api.get(`/api/distributions/instructor/${instructorId}`, { params })
}

export const goLiveSectionApi = async (params: Record<string, any>): Promise<AxiosResponse> => {
  return await api.post(`/api/distributions/?slot_id=${params.slotId}&section_id=${params.sectionId}`)
}

export const getInstructorDistributions = async (params: Record<string, any>): Promise<AxiosResponse> => {
  return await api.get('/api/distributions/instructor/', { params })
}

export const getAdminDistributions = async (params: Record<string, any>): Promise<AxiosResponse> => {
  return await api.get('/api/distributions/admin/', { params })
}

const getDistributionSeriesBySeriesId = async (seriesId: string): Promise<AxiosResponse> => {
  return await api.get(`/api/distribution_series/${seriesId}`)
}

const getSlotsForDistributionSeriesBySeriesId = async (seriesId: string): Promise<AxiosResponse> => {
  return await api.get(`/api/distribution_series/${seriesId}/slots/`)
}

const exportSectionsCSV = async (params: { slotId: string, search?: string, sort?: string, pageSize?: number }): Promise<AxiosResponse> => {
  const { slotId, ...queryParams } = params
  return await api.get(`/api/slots/${slotId}/sections/export/`, { params: queryParams })
}

export const resetCourseSections = async (slotId: string): Promise<AxiosResponse> => {
  return await api.delete(`/api/slots/${slotId}/sections/reset/`)
}

export const getSlot = async (slotId: string): Promise<AxiosResponse> => {
  return await api.get(`/api/slots/${slotId}`)
}

const deleteSlotBySlotId = async (slotId: string): Promise<AxiosResponse> => {
  return await api.delete(`/api/slots/${slotId}`)
}

export {
  getDistributionSeriesBySeriesId,
  getSlotsForDistributionSeriesBySeriesId,
  deleteSlotBySlotId
}

export default {
  exportPdf,
  exportPDFByInstructorId,
  exportCSV,
  exportCSVByInstructorId,
  getAllDistributionSeries,
  getInstructorDistributionsById,
  getInstructorDistributions,
  goLiveSectionApi,
  getAdminDistributions,
  exportSectionsCSV,
  resetCourseSections,
  getDistributionById,
  deleteProject,
  getProjectById,
  updateProject,
  createProject,
  deleteSlotBySlotId,
  updateDistributionPlan,
  getSlot,
  createDistributionPlan
}
